type OffscreenCanvasHost = {OffscreenCanvas?: unknown; document: Pick<Document, 'createElement'>};

/**
 * Safari before 16.4 has no OffscreenCanvas, which the editor uses for the screen and every layer buffer.
 * A detached canvas element offers the same 2D drawing API, so it stands in there.
 */
export function installOffscreenCanvasPolyfill(host: OffscreenCanvasHost): void {
    if (typeof host.OffscreenCanvas !== 'undefined') return;
    const createElement = host.document.createElement.bind(host.document);
    host.OffscreenCanvas = function OffscreenCanvas(width: number, height: number) {
        const canvas = createElement('canvas') as HTMLCanvasElement & Pick<OffscreenCanvas, 'convertToBlob'>;
        canvas.width = width;
        canvas.height = height;
        canvas.convertToBlob = (options?: ImageEncodeOptions) =>
            new Promise<Blob>((resolve, reject) =>
                canvas.toBlob(
                    (blob) => (blob ? resolve(blob) : reject(new Error('The canvas could not be encoded.'))),
                    options?.type,
                    options?.quality,
                ),
            );
        return canvas;
    };
}
